import { useEffect } from "react"
import Container from "../components/base/container"
import PageLayout from "../components/base/page-layout"
import Heading from "../components/common/heading"
import { recordPageView } from "../utils/utility"

const About = () => {

  useEffect(() => {
    recordPageView("/aboutus.html")
  }, [])

  return (
    <>
      <PageLayout pageTitle="About Us" headTitle="About Lamudi" className="staticPageBanner">
        <Container className="u-mb24">
          <Heading variant="h2">Overview</Heading>

          <Heading variant="h3">What Is Lamudi.pk?</Heading>
          <p>
            We are a property portal which aims to take Pakistani real estate to another level of excellence. The
            internet has revolutionised almost every sector, and real estate should be no different. So, we directly
            connect buyers with sellers and tenants with landlords to make the whole property process as simple as
            possible. Whatever your property buying or selling requirements are, we give you a large number of options
            to cater to them. <br />
            <br />
            Imagine having access to the real estate market of Pakistan in the palm of your hand! That's what{" "}
            <a href="https://www.lamudi.pk">Lamudi.pk</a> is giving you. Our highly qualified team is working to provide
            a premium property experience in the most convenient way.{" "}
          </p>

          <Heading variant="h3">Our Journey</Heading>
          <p>
            Understanding the pulse of the local market is necessary to achieve our goals and become a worthy member of
            the industry. We have utilised market research and extensive data analysis to present the best property
            solutions in the form of a portal that is user-friendly and accessible for everyone.{" "}
          </p>

          <Heading variant="h3">Our Goals</Heading>
          <p>
            We believe that no one should have to go through the hassle of running around and having to go to multiple
            resources to make any property transaction, no matter how big or small. Our aim is to make things easier for
            you, so you can make property decisions by just exploring our website. <br />
            <br />
            Another major goal is to make Pakistani property accessible to all. Whether you're a businessman, a
            corporate employee, a widow, or an overseas Pakistani looking for property in Pakistan, we cater to your
            real estate needs by connecting you with a vast database of sellers. With{" "}
            <a href="https://www.lamudi.pk">Lamudi.pk</a>, you can check out property options from all over Pakistan in
            one place!
          </p>
        </Container>
      </PageLayout>
    </>
  )
}

export default About
